import { CreateCodeArguments } from '../../components/Homepage/CreateFlowcodeForm/CreateFlowcodeFormDesktop/CreateFlowcodeFormDesktop.hooks'
import { GENERATOR_FORM_CACHE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { logger } from '@dtx-company/logger'

export async function setGeneratorFormCache({
  formValues
}: {
  formValues: CreateCodeArguments
}): Promise<boolean> {
  try {
    const res = await fetch(GENERATOR_FORM_CACHE_ENDPOINT, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({ formValues }),
      headers: {
        'Content-type': 'application/json'
      }
    })
    if (!res.ok) {
      await logger.logFetchError(res, { technicalArea: 'authentication' })
    }
    return res.ok
  } catch (e) {
    logger.logError(e, { technicalArea: 'authentication' })
    return false
  }
}
